<template>
    <basket-value :hide-if-empty="blok.hide_if_empty" :displayTax="blok.display_tax"></basket-value>
</template>
<script>
import BasketValue from "../../../components/cart/BasketValue.vue";

export default {
    name: 'basket-total',
    props: {
        blok: Object
    },
    components: {
        BasketValue,
    }    
}
</script>
